import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Box } from "@whoosh/design-system/src/components/primitive";

import { BookingReservation } from "../BookingReservation/BookingReservation";
import { ChargesSummary } from "../ChargesSummary/ChargesSummary";
import { BookingPayment_Booking$key } from "./__generated__/BookingPayment_Booking.graphql";

type Props = {
  handleGoBack: () => void;
  bookingFragmentRef: BookingPayment_Booking$key | null;
  currentServerTime?: string | null;
  membershipTypeId: string;
  isMemberCaller: boolean;
  hasPublicSeenNotificationNudgeModal?: boolean;
  isBookingOwner: boolean;
  showLoyaltyEnrollment?: boolean;
  requestGroupCount?: number;
};

export const BookingPayment = ({
  handleGoBack,
  bookingFragmentRef,
  currentServerTime,
  membershipTypeId,
  isMemberCaller,
  hasPublicSeenNotificationNudgeModal,
  isBookingOwner,
  showLoyaltyEnrollment,
  requestGroupCount = 1,
}: Props) => {
  const booking = useFragment(BookingPaymentFragmentString, bookingFragmentRef);

  return (
    <Box>
      <Box
        marginLeft={8}
        marginTop={8}
        width={368}
        backgroundColor="grayscale-0"
        borderRadius="4"
        overflow="hidden"
        style={{ borderWidth: 1.5 }}
        borderColor="outline-default"
        shadowColor="black"
        shadowOffset={{ width: 0, height: 8 }}
        shadowOpacity={0.06}
        shadowRadius={24}
      >
        {bookingFragmentRef ? (
          <ChargesSummary
            bookingRef={booking ?? null}
            isBookingOwner={isBookingOwner}
            showLoyaltyEnrollment={showLoyaltyEnrollment}
          />
        ) : null}
        <BookingReservation
          bookingFragmentRef={booking ?? null}
          currentServerTime={currentServerTime}
          handleGoBack={handleGoBack}
          isMemberCaller={isMemberCaller}
          membershipTypeId={membershipTypeId}
          hasPublicSeenNotificationNudgeModal={
            hasPublicSeenNotificationNudgeModal
          }
          isBookingOwner={isBookingOwner}
          requestGroupCount={requestGroupCount}
        />
      </Box>
    </Box>
  );
};

const BookingPaymentFragmentString = graphql`
  fragment BookingPayment_Booking on Booking
  @argumentDefinitions(
    patronLoyalty: { type: "Boolean!", defaultValue: false }
  ) {
    ...BookingReservation_Booking @arguments(patronLoyalty: $patronLoyalty)
    ...BookingPaymentMethodSelect_booking
    ...ChargesSummary_booking @arguments(patronLoyalty: $patronLoyalty)
  }
`;
